import { render, staticRenderFns } from "./NoAvailableBoxesModal.vue?vue&type=template&id=93587170&scoped=true&lang=pug&"
import script from "./NoAvailableBoxesModal.vue?vue&type=script&lang=js&"
export * from "./NoAvailableBoxesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93587170",
  null
  
)

export default component.exports